export const Privileges = Object.freeze({
    VIEW: 'VIEW', //0
    DELETE: 'DELETE', //1
    MODIFY: 'MODIFY', //2
    CREATE: 'CREATE', //3
    SEND: 'SEND', //4
    CANCEL: 'CANCEL', //5
    SCHEDULER: { //6
        RESERVATION: 'RESERVATION',
        REFUND: 'REFUND',
    },
    PLAN: { //7
        MANAGE_ONE_TIME_ACTIVATION_FEE: 'MANAGE_ONE_TIME_ACTIVATION_FEE',
        MANAGE_CLUB_PLAN: 'MANAGE_CLUB_PLAN',
        MANAGE_PLATFORM_PLAN: 'MANAGE_PLATFORM_PLAN',
        MANAGE_CANCEL_USER_PLAN: 'MANAGE_CANCEL_USER_PLAN',
    },
    NOTIFICATION: { //8
        MANAGE_EMAIL_NOTIFICATION: 'MANAGE_EMAIL_NOTIFICATION',
    },
    CALENDAR_SETTING: {  //9
        MANAGE_COURT: 'MANAGE_COURT',
        MANAGE_CLUB_TIME: 'MANAGE_CLUB_TIME',
        MANAGE_TIMEZONE_INTERVAL: 'MANAGE_TIMEZONE_INTERVAL',
    },
    INVITE_STAFF: {  //10
        MANAGE_INVITE_STAFF: "MANAGE_INVITE_STAFF"
    },
    REGISTRATION_SETUP: { //11
        MANAGE_FORM_TEMPLATE: "MANAGE_FORM_TEMPLATE",
        MANAGE_FORM_TEMPLATE_APPROVAL: "MANAGE_FORM_TEMPLATE_APPROVAL",
        MANAGE_FORM_OVERVIEW: "MANAGE_FORM_OVERVIEW",
        MANAGE_FORM_FIELD: "MANAGE_FORM_FIELD",
        MANAGE_PARTICIPANT_FEE: "MANAGE_PARTICIPANT_FEE",
        MANAGE_WAIVER: "MANAGE_WAIVER",
        MANAGE_PAYMENT: "MANAGE_PAYMENT",
        MANAGE_PLAYER_APPROVAL: "MANAGE_PLAYER_APPROVAL"
    },
    EVENT: {  //12
        MANAGE_EVENT: "MANAGE_EVENT"
    },
    ROSTER: {  //13
        MANAGE_ROSTER: "MANAGE_ROSTER"
    },
    CLUB_SETUP:{  //14
        MANAGE_CLUB_PROFILE:"MANAGE_CLUB_PROFILE",
        MANAGE_CLUB_JOIN_REQUEST:"MANAGE_CLUB_JOIN_REQUEST"
    },
    DOWNLOAD:"DOWNLOAD", //15
    TEAM:{ //16
        MANAGE_TEAM:"MANAGE_TEAM"
    },
    REFUND:"REFUND", //17
    MY_FINANCES:{ //18
        MANAGE_TRANSACTION:"MANAGE_TRANSACTION",
        MANAGE_PAYOUT:"MANAGE_PAYOUT",
        MANAGE_ACCOUNT:"MANAGE_ACCOUNT"
    },
    ADS_SPONSORSHIP: {
        MANAGE_SPONSOR: "MANAGE_SPONSOR",
        MANAGE_SPONSORSHIP: "MANAGE_SPONSORSHIP",
        MANAGE_SPONSORSHIP_PAYMENT: "MANAGE_SPONSORSHIP_PAYMENT",
        MANAGE_ADVERTISEMENT: "MANAGE_ADVERTISEMENT",
        MANAGE_AD_ANALYTICS: "MANAGE_AD_ANALYTICS"
    }
});